"use client";

import { VariantProps } from "class-variance-authority";
import { useRouter } from "next/navigation";
import { useCallback } from "react";

import AuthDialog from "@/app/(discover)/components/auth-dialog";
import { formMode } from "@/components/auth/form-mode";
import { Button, buttonVariants } from "@/components/ui/button";
import useSignUpDrawer from "@/hooks/use-sign-up-drawer";
import { authTestIds } from "@/lib/data-test-ids/components.data-test-ids";
import routes from "@/lib/routes";
import { cn } from "@/lib/utils";

interface SignUpButtonWrapperProps {
  variant?: VariantProps<typeof buttonVariants>["variant"];
  className?: string;
  label?: string;
  testId?: string;
}

export default function SignUpButtonWrapper({
  variant = "default",
  className,
  label = "Create free profile",
  testId = authTestIds.SIGN_UP_BUTTON,
}: SignUpButtonWrapperProps) {
  const router = useRouter();
  const { isOpen, openDrawer, closeDrawer } = useSignUpDrawer();

  const handleOpenDialog = useCallback(() => {
    openDrawer("1");
  }, [openDrawer]);

  const handleSuccess = useCallback(() => {
    router.push(routes.getProfileInfo());
  }, [router]);

  return (
    <div>
      <Button
        onClick={handleOpenDialog}
        variant={variant}
        className={cn(
          "h-10 px-6 rounded-lg font-medium cursor-pointer",
          variant === "outline" &&
            "border border-line-strong bg-card text-ink-emphasis hover:bg-surface-subtle",
          className,
        )}
        data-testid={testId}
      >
        {label}
      </Button>
      <AuthDialog
        mode={formMode.signup}
        isOpen={isOpen}
        onClose={closeDrawer}
        onSuccess={handleSuccess}
      />
    </div>
  );
}
